const cache = new Map();

/**
 * Get a cross origin file url. If the url is not same origin, it will return a blob url.
 * Bypassing limitations of cross origin workers for example.
 *
 * @example
 * window.location.origin = 'https://example.com';
 *
 * getCrossOriginWorkerUri('/worker.js') // 'https://example.com/worker.js'
 * getCrossOriginWorkerUri('https://cdn.com/worker.js') // 'blob:https://example.com/41e77bad-c060-4cf2-9c2b-d241eb4a7200'
 */
export function getCrossOriginWorkerUri(workerUri: string) {
  if (cache.has(workerUri)) return cache.get(workerUri);

  const { origin, protocol } = new URL(workerUri, window.location.origin);
  const isSameOrigin = origin === window.location.origin;
  const isDataUri = protocol === 'data:';

  if (isSameOrigin || isDataUri) return workerUri;

  const script = `importScripts('${workerUri}');`;
  const blob = new Blob([script], { type: 'application/javascript' });
  const tmpUrl = URL.createObjectURL(blob);

  cache.set(workerUri, tmpUrl);

  return tmpUrl;
}
